<template>
<div>
  <v-cardbuy v-if="isCardbuy"></v-cardbuy>

  <v-cellorder v-if="isCellorder"></v-cellorder>

  <v-storepay v-if="isStorepay"></v-storepay>
</div>
</template>

<script>
  import router from '../../router'
  import cardbuy from '@/components/pay/cardbuy.vue'
  import cellorder from '@/components/pay/cellorder.vue'
  import storepay from '@/components/pay/storepay.vue'
export default {
  name: 'user',
  data () {
    return {
      isCardbuy:false,
      isCellorder:false,
      isStorepay:false,
    }
  },
  created() {
    if(this.$route.params.id == 'cardbuy'){
      this.isCardbuy = true
    }else if(this.$route.params.id == 'cellorder'){
      this.isCellorder = true
    }else if(this.$route.params.id == 'storepay'){
      this.isStorepay = true
    }
  },
  components: {
    'v-cardbuy':cardbuy,
    'v-cellorder':cellorder,
    'v-storepay':storepay
  },
  methods: {

  },
}
</script>




// WEBPACK FOOTER //
// src/pages/qcode/pay.vue